// extracted by mini-css-extract-plugin
module.exports = {"hz-Listing-urgency-badge":"ListingFigureMainImage_hz-Listing-urgency-badge__5rTE4","hz-Badge":"ListingFigureMainImage_hz-Badge__4oz3_"};